class DbrHeader extends HTMLElement {
  constructor() {
    super();
    this.onScroll = this.onScroll.bind(this);
    this.onBurgerClick = this.onBurgerClick.bind(this);
    this.updateAnnouncementOffset = this.updateAnnouncementOffset.bind(this);
  }

  connectedCallback() {
    this.burger = this.querySelector('.dbr-header__burger');
    this.mobileMenu = this.querySelector('.dbr-header__mobile-menu');

    if (this.burger && this.mobileMenu) {
      this.burger.addEventListener('click', this.onBurgerClick);
    }

    if (this.classList.contains('dbr-header--overlay') || this.classList.contains('dbr-header--sticky')) {
      this.updateAnnouncementOffset();
      window.addEventListener('resize', this.updateAnnouncementOffset, { passive: true });
      window.addEventListener('load', this.updateAnnouncementOffset);
    }

    if (this.classList.contains('dbr-header--force-scrolled')) {
      // Ajuste por página > "Manter aparência do sticky (sempre)": nasce com o visual
      // de rolado e fica assim pra sempre — sem listener de scroll, senão o próprio
      // onScroll tiraria a classe de novo ao voltar pro topo (scrollY <= 8).
      this.classList.add('is-scrolled');
    } else if (this.classList.contains('dbr-header--sticky') || this.classList.contains('dbr-header--glass')) {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.updateAnnouncementOffset);
    window.removeEventListener('load', this.updateAnnouncementOffset);
  }

  updateAnnouncementOffset() {
    const announcementBar = document.querySelector('.announcement-bar-section');
    const announcementHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
    this.style.setProperty('--dbr-announcement-height', `${announcementHeight}px`);

    const headerHeight = this.getBoundingClientRect().height;
    document.documentElement.style.setProperty(
      '--dbr-header-total-height',
      `${announcementHeight + headerHeight}px`
    );
  }

  onScroll() {
    this.classList.toggle('is-scrolled', window.scrollY > 8);
  }

  onBurgerClick() {
    const isOpen = this.classList.toggle('is-menu-open');
    this.burger.setAttribute('aria-expanded', isOpen);
    this.mobileMenu.hidden = !isOpen;
  }
}

customElements.define('dbr-header', DbrHeader);
